import React from 'react';
import { bunnyFaqs } from '../../bunnyMock';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../ui/accordion';

const BunnyFAQSection = () => {
  return (
    <section id="faq" className="section-spacing bunny-section-light">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-5xl sm:text-6xl font-serif bunny-headline text-gray-900 mb-6">
            Got Questions?
          </h2>
          <p className="text-xl text-gray-700 font-sans">
            Everything you need to know about Waisted Bunny
          </p>
        </div>

        <Accordion type="single" collapsible className="space-y-4">
          {bunnyFaqs.map((faq) => (
            <AccordionItem 
              key={faq.id} 
              value={`item-${faq.id}`}
              className="bunny-card px-8 border-2 border-gray-900"
            >
              <AccordionTrigger className="text-left font-sans font-bold text-gray-900 hover:text-pink-600 py-6">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-gray-700 font-sans leading-relaxed pb-6">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default BunnyFAQSection;
